import { useEffect, useState } from 'react';
import {
  OrderItemsAndActionsProps,
  OrderProductListItem,
  PrescriptionStatus,
  SelectedToken,
  SubstituteToken,
} from '../interface/interface';
import CollapsibleDataTable from './TableWithCollapsibleRows';
import { getOrderProductDetailsById } from '../service';
import ProductAlerts from './ProductAlerts';
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import SubstituteTokenTable from '../views/SubstituteTokenTable';
import MultiStepModal from './MultiStepModal';
import instance from '../config/axios';
import showToast from './ToastComponent';
import Loading from './Loading';
import { createSubstituteToken } from '../service/createSubstituteToken';
import { StepOne } from './step1Component';

const OrderItemsAndActions = (props: OrderItemsAndActionsProps) => {
  const [isProductDetailSectionLoading, setProductDetailSectionLoadingStatus] =
    useState<boolean>(false);
  const [orderProductsList, setOrderProductList] = useState<
    Array<OrderProductListItem>
  >([]);

  const visibleColumns = [
    'Product Name',
    'Ordered Qty',
    'Unit Price',
    'Rx Date',
    'Prescription Token',
    'Prescription Status',
    'Remaining Repeats',
    'Used Monthly Limit',
    // 'Remaining Qty',
  ];
  const hiddenColumns = [
    'Token',
    'Prescriber',
    'Script Number',
    'Prescription Product Name',
    'Prescribed Quantity',
    'Actual Prescription Repeat',
    'SAS-B Reference',
  ]
    .filter(
      (f) =>
        f !==
        (!orderProductsList?.find((e) => e.substituteProduct?.substituteFlag)
          ? 'Token'
          : ''),
    )
    .filter(
      (f) =>
        f !==
        (!orderProductsList?.find((e) => e.product.isSASBProduct)
          ? 'SAS-B Reference'
          : ''),
    );

  const [exstingProuductList, setExistingProductLis] = useState<
    Array<OrderProductListItem>
  >([]);

  const [substituedProductList, setSubstituedProductList] = useState([]);

  const [currentStep, setCurrentStep] = useState<number>(0);

  const [selecteToken, setSelectToken] = useState<SelectedToken>();

  const [substituteToken, setSubstituteToken] = useState<SubstituteToken>();

  const [isModalDataLoaded, setModalLoader] = useState<boolean>(false);

  const [hasExpiredPrescription, setHasExpiredPrescription] =
    useState<boolean>(false);

  const [existingPrescriptionList, setExistingPrescriptionList] = useState<
    Array<OrderProductListItem>
  >([]);

  useEffect(() => {
    if (!orderProductsList.length) return;

    const subsProduct = orderProductsList.find(
      (e) => e?.substituteProduct?.substituteFlag,
    );

    const expiredPresciption = orderProductsList.some(
      (e) =>
        (e?.prescription?.status === PrescriptionStatus.Expired &&
          !e?.subsPrescription?.id) ||
        (e.subsPrescription &&
          e.subsPrescription.status === PrescriptionStatus.Expired),
    );
    props.setPresciptionExpiryFlag(Boolean(expiredPresciption));
    props.setSubsFlag(Boolean(subsProduct));
    setHasExpiredPrescription(Boolean(expiredPresciption));
  }, [orderProductsList]);

  useEffect(() => {
    if (!props.orderId || !props?.accessToken) return;
    setProductDetailSectionLoadingStatus(true);
    getOrderProductDetailsById(props?.accessToken, props.orderId).then(
      async (data) => {
        if (typeof data === 'number') {
          setOrderProductList([]);
          setProductDetailSectionLoadingStatus(false);
          return;
        }
        if (props?.sasProductData)
          props.sasProductData(
            data?.filter(
              (product: OrderProductListItem) => product.product.isSASBProduct,
            ),
          );
        setOrderProductList(data);
        props.setOrderProductsList(
          data?.filter(
            (product: OrderProductListItem) => product.orderedQty > 0,
          ),
        );
        setExistingProductLis(
          data?.filter(
            (x: { substituteProduct: { substituteFlag: boolean } }) =>
              x?.substituteProduct?.substituteFlag,
          ),
        );
        setExistingPrescriptionList(
          data?.filter(
            (x: { prescription: { status: string } }) =>
              x?.prescription.status === PrescriptionStatus.Expired,
          ),
        );
        setProductDetailSectionLoadingStatus(false);
      },
    );
  }, [props.orderId, props.refreshKey]);

  useEffect(() => {
    if (!props.modalProps.isMModalVisible) {
      setSelectToken(undefined);
      setSubstituteToken(undefined);
    }
  }, [props.modalProps.isMModalVisible]);

  const StepTwo = () => (
    <div>
      {isModalDataLoaded ? (
        <p className="text-base text-primary-blue-500 font-semibold text-center">
          Loading...
        </p>
      ) : (
        <>
          {substituedProductList.length ? (
            <>
              <p className="text-primary-blue-500 text-sm mb-3 font-semibold">
                Select the token to be added
              </p>
              <SubstituteTokenTable
                step={2}
                data={substituedProductList}
                token={{
                  state: selecteToken,
                  setter: setSelectToken,
                }}
                substituteToken={{
                  state: substituteToken,
                  setter: setSubstituteToken,
                }}
              />
            </>
          ) : (
            <p className="text-base text-primary-blue-500 font-semibold text-center">
              No records to display
            </p>
          )}
        </>
      )}
    </div>
  );

  const steps = [
    <StepOne
      exstingProuductList={exstingProuductList}
      selecteToken={selecteToken}
      setSelectToken={setSelectToken}
      substituteToken={substituteToken}
      setSubstituteToken={setSubstituteToken}
      type={props.tokenType}
      existingPrescriptionList={existingPrescriptionList}
      key="1"
    />,
    <StepTwo key="2" />,
  ];

  const handleNext = () => {
    if (!props.accessToken) {
      showToast({
        message: 'Access Token not found',
        type: 'warning',
      });
      return;
    }
    if (!props.patient.id || !selecteToken?.productId) {
      showToast({
        message: 'Patient or Product Not found',
        type: 'warning',
      });
      return;
    }

    setModalLoader(true);
    instance({
      method: 'GET',
      url: `/api/v1/prescription/patient/${props.patient.id}/product/${selecteToken.productId}`,
      headers: {
        Authorization: `Bearer ${props?.accessToken}`,
      },
    }).then((res) => {
      if (res.status === 200) {
        setSubstituedProductList(
          res.data.map((pres: any) => ({
            id: pres?.id,
            productId: pres?.product?.id,
            Token: pres?.token,
            'Product Name': pres?.product?.name,
            'Prescribed Qty': pres?.prescribed_quantity,
            'Remaining Repeats': pres?.remaining_repeats,
          })),
        );

        if (currentStep < steps.length - 1) {
          setCurrentStep(currentStep + 1);
        }

        setModalLoader(false);
      }
    });
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = async () => {
    if (!props.accessToken) {
      showToast({
        message: 'Access Token not found',
        type: 'warning',
      });
      return;
    }

    if (!props.patient.email || !props.orderId) {
      showToast({
        message: 'Patient Email or Order Id not found',
        type: 'warning',
      });
      return;
    }
    if (!selecteToken?.token || !substituteToken?.token) {
      showToast({
        message: 'Existing Token or Substitue Token Not found',
        type: 'warning',
      });
      return;
    }
    setModalLoader(true);
    const response = await createSubstituteToken(
      {
        patientEmail: props?.patient.email,
        token: selecteToken?.token,
        substituteToken: substituteToken.token,
        orderId: props.orderId,
        hasExpiredPrescription: hasExpiredPrescription,
      },
      props.accessToken,
    );
    if (typeof response === 'number') {
      showToast({
        type: 'warning',
        message: 'Unable to Create Prescription',
      });
    } else {
      showToast({
        type: 'success',
        message: response?.info,
      });
    }
    setModalLoader(false);
    props.modalProps.closeMultiModal();
    props.refreshParent();
  };

  if (isProductDetailSectionLoading) <Loading />;

  return (
    <>
      <CollapsibleDataTable
        data={orderProductsList.map(
          (orderProductDetail, orderProductIndex) => ({
            hideHiddenColumns: !orderProductDetail.product.requiresPrescription,
            'Product Name': (
              <ProductAlerts
                orderProduct={orderProductDetail}
                index={orderProductIndex}
                isVerfiedProduct={orderProductDetail.is_verified_from_shopify}
                currentStatus={props.currentStatus}
              />
            ),
            'Ordered Qty': orderProductDetail.orderedQty,
            'Unit Price': (
              <NumericFormat
                value={orderProductDetail.price}
                prefix="$"
                readOnly
                displayType="text"
                decimalScale={2}
                fixedDecimalScale
              />
            ),
            'Rx Date': moment(
              orderProductDetail?.prescription?.prescriptionDate,
            ).isValid()
              ? moment(
                  orderProductDetail?.prescription?.prescriptionDate,
                ).format('DD/MM/YYYY')
              : '-',
            'Prescription Token': (
              <div>
                <p>{orderProductDetail?.token_while_ordering}</p>
                {(orderProductDetail?.subsPrescription?.status ===
                  PrescriptionStatus.Active ||
                  orderProductDetail?.substitute_token) && (
                  <p className="font-bold mt-2">
                    {orderProductDetail?.subsPrescription
                      ? orderProductDetail?.subsPrescription?.token
                      : orderProductDetail?.substitute_token}
                    *
                  </p>
                )}
              </div>
            ),
            'Prescription Status':
              orderProductDetail?.prescription?.status ?? '-',
            'Remaining Repeats':
              orderProductDetail?.prescription?.repeatsRemaining ?? '-',
            'Used Monthly Limit': orderProductDetail?.product?.monthlyLimit,
            // 'Remaining Qty':
            //   orderProductDetail.prescription.remainingQty ?? '-',
            Prescriber: (
              <div>
                <p className="text-left">
                  {orderProductDetail?.prescription?.prescriber ?? '-'}
                </p>
                {orderProductDetail?.subsPrescription?.prescriber && (
                  <p className="font-bold mt-2">
                    {orderProductDetail?.subsPrescription?.prescriber}*
                  </p>
                )}
              </div>
            ),
            'Script Number': (
              <div>
                <p className="text-left">
                  {orderProductDetail?.prescription?.scriptNumber ?? '-'}
                </p>
                {orderProductDetail?.subsPrescription?.scriptNumber && (
                  <p className="font-bold mt-2">
                    {orderProductDetail?.subsPrescription?.scriptNumber}*
                  </p>
                )}
              </div>
            ),
            'Prescription Product Name': (
              <div>
                <p className="text-left">
                  {orderProductDetail?.prescription?.productName ?? '-'}
                </p>
                {orderProductDetail?.subsPrescription?.productName && (
                  <p className="font-bold mt-2">
                    {orderProductDetail?.subsPrescription?.productName}*
                  </p>
                )}
              </div>
            ),

            'Prescribed Quantity': (
              <div>
                <p>{orderProductDetail?.prescription?.prescribedQty ?? '-'}</p>{' '}
                {orderProductDetail?.subsPrescription?.prescribedQty && (
                  <p className="font-bold mt-2">
                    {orderProductDetail?.subsPrescription?.prescribedQty}*
                  </p>
                )}
              </div>
            ),
            'Actual Prescription Repeat': (
              <div>
                <p>
                  {orderProductDetail?.prescription?.prescribedRepeats ?? '-'}
                </p>
                {orderProductDetail?.subsPrescription?.prescribedRepeats && (
                  <p className="font-bold mt-2">
                    {orderProductDetail?.subsPrescription?.prescribedRepeats}*
                  </p>
                )}
              </div>
            ),
            Token: (
              <div>
                <p className="text-left">
                  {orderProductDetail?.prescription.token ?? '-'}
                </p>
                {(orderProductDetail?.subsPrescription?.status ===
                  PrescriptionStatus.Active ||
                  orderProductDetail?.substitute_token) && (
                  <p className="font-bold mt-2">
                    {orderProductDetail?.subsPrescription
                      ? orderProductDetail?.subsPrescription?.token
                      : orderProductDetail?.substitute_token}
                    *
                  </p>
                )}
              </div>
            ),
            'SAS-B Reference': (
              <p className="text-left">
                {orderProductDetail?.product.sasbReferenceId ?? '-'}
              </p>
            ),
            invalid: !!orderProductDetail?.invalidReason,
          }),
        )}
        visibleColumns={visibleColumns}
        hiddenColumns={hiddenColumns}
      />
      <MultiStepModal
        headerText={
          hasExpiredPrescription
            ? 'Replace Expired Prescription'
            : 'Add Substitute Token'
        }
        steps={steps}
        visible={props.modalProps.isMModalVisible}
        onClose={props.modalProps.closeMultiModal}
        modalSize="w-10/12"
        selecteToken={selecteToken}
        substituteToken={substituteToken}
        step={{
          state: currentStep,
          setter: setCurrentStep,
        }}
        handleNext={handleNext}
        handlePrev={handlePrevious}
        handleSubmit={handleSubmit}
      />
    </>
  );
};
export default OrderItemsAndActions;
